module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAARVBMVEUAAACZmZmZmZmampqYmJibm5uZmZmampqampqampqYmJiZmZmZmZmampqampqZmZmbm5uAgICZmZmampqZmZmcnJwAAACL/n+tAAAAF3RSTlMA/vJrDBrkmnVaI7auqU0mHAJfn90xASwevl8AAAC2SURBVCjPrZLLFoIgFEU5l5cIiGX1/59aFngsBg5yT4C1F9wHV53ArKMTcVHPnbIeG95+u0mAHIoxJWRApr3TQBrbYUyAppuAQe0YgO2uleaMaVZaXI9Ud+5WNwm+1gDUeBegxQXmmk1WlJVcc4oIvQyIn0AovSxw71VgKJdl8WsGBvIjH4KVgXL3rLpfXwSzPcuECBNiKYSlsAlkBCzbR9g+Np6w8QdfdvTZ/ZgcDxjhaFr1P0+PuAXl2NzGBAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/time.png
// module id = L7xM
// module chunks = 1